import styled from 'styled-components';

export const StyledSocialIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 5px solid ${(props) => props.color};
  transition: all 0.5s;
  font-size: 24px;
  background: ${(props) => props.color};
  color: #ffffff;
  &:hover {
    transform: rotate(360deg)scale(1.3);
    background: #ffffff;
    color: ${(props) => props.color};
  }
    `;

export const StyledSocialIconLink = styled.a`
text-decoration: none;

a:hover, a:focus, a:active {
text-decoration: none;
}
`

export const StyledSocialIconWrapper = styled.div`
display: flex;
align-items: center;    
justify-content: space-evenly;
margin: auto;
width: 260px;
flex: 1;
`;
